<template>
  <span>
    <i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true" />
    <span class="sr-only">Loading...</span>
  </span>
</template>

<script>
export default {
  name: 'loader',
};
</script>



// WEBPACK FOOTER //
// src/components/Loader.vue